<div class="container simple-notification" fxLayout="column" fxFlexAlign="center center">

  <div class="notify" fxFlexAlign="center">
    <div class="notify__description" [innerHTML]="(shouldTranslateMessage ? (message | translate) : message) | safeHtml"></div>
  </div>

  <app-container-spinner *ngIf="loaderVisible"></app-container-spinner>
</div>
